import React, { ReactNode } from 'react';
import { Cover } from './Cover';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface ICoverWrapperProps {
  showCover: boolean;
  coverMessage?: ReactNode;
  clickThrough?: boolean;
}

export const CoverWrapper: FCWithChildren<ICoverWrapperProps> = ({
  children,
  showCover,
  coverMessage,
  clickThrough,
}) => (
  <div style={{ position: 'relative' }}>
    {children}
    {showCover && <Cover clickThrough={clickThrough}>{coverMessage}</Cover>}
  </div>
);
